'use client';
import SchedulePopup from "./SchedulePopup";
import ScheduleAddCreate from "./ScheduleAddCreate";
import { getProgressFromDB, getQuestProgress, QuestProgress, getScheduleFromDB, Schedule } from "@/constant/schedule";
import { useEffect, useState } from "react";
import useAuthStore from "@/store/useAuthStore";
import { useQuickScheduleStore } from "@/store/useQuickScheduleStore";
import ScheduleReminder from "./ScheduleReminder";

export default function QuickSchedule() {
  const user = useAuthStore(state => state.user);
  const hide = useQuickScheduleStore(state => state.hide);
  const quest = useQuickScheduleStore(state => state.params?.quest);
  const step = useQuickScheduleStore(state => state.step);
  const daysToBeAdded = [0, 2, 4, 6].includes(new Date().getDay()) ? [0, 2, 4, 6] : [1, 3, 5];
  const setStep = useQuickScheduleStore(state => state.setStep);
  const triggerRefresh = useQuickScheduleStore(state => state.triggerRefresh);
  const [allQuestProgress, setAllQuestProgress] = useState<QuestProgress[] | null>([]);
  const [existingSchedule, setExistingSchedule] = useState<Schedule | null>(null);
  const [isLoadingSchedule, setIsLoadingSchedule] = useState(false);
    
  useEffect(() => {
    const fetchAllQuestProgress = async () => {
      if (!user || !user.id) return;
      const allQuestProgress = await getProgressFromDB(user.id);
      setAllQuestProgress(allQuestProgress);
    }
    fetchAllQuestProgress();
  }, [user]);

  useEffect(() => {
    const fetchExistingSchedule = async () => {
      if (!user || !user.id || !quest || !quest.id) {
        setExistingSchedule(null);
        setIsLoadingSchedule(false);
        return;
      }
      setIsLoadingSchedule(true);
      const schedule = await getScheduleFromDB(user.id, quest.id);
      setExistingSchedule(schedule || null);
      setIsLoadingSchedule(false);
    }
    fetchExistingSchedule();
  }, [user, quest]);

  if (step === 0 || !quest) return null;

  const handleAddClick = () => {
    setStep(2);
  }

  const handleCreated = () => {
    triggerRefresh();
    setStep(3);
  }

  return (
    <SchedulePopup onClose={hide}>
      {step === 1 && <ScheduleReminder iconUrl={"/assets/schedule-reminder.png"} title="Keep Up the Great Work!" description={<>Want more gems? 💎💎💎 Set your learning schedule now - earn <strong>10 extra gems</strong> for every lesson you complete! 🚀</>} buttonText="Add a Schedule to This Book" onButtonClick={handleAddClick} />}
      {step === 2 && <ScheduleAddCreate questToBeAdded={quest || null} questProgress={getQuestProgress(quest!, allQuestProgress || [])} update={existingSchedule !== null} onCreated={handleCreated} defaultDays={existingSchedule ? existingSchedule.days : daysToBeAdded} defaultLessonsPerDay={existingSchedule?.lessons_per_day} simple={true} isLoadingSchedule={isLoadingSchedule} />}
      {step === 3 && <ScheduleReminder iconUrl={"/assets/schedule-added-pengi.png"} title="Schedule Added!🎉" description="You're all set to keep learning on track." buttonText="OK" onButtonClick={hide} />}
    </SchedulePopup>
  );
}
